//#region src/order_state.ts
let OrderState = /* @__PURE__ */ function(OrderState) {
	OrderState["Basket"] = "basket";
	OrderState["Closed"] = "closed";
	OrderState["FailedToClose"] = "failed-to-close";
	OrderState["Sent"] = "sent";
	OrderState["FailedToSend"] = "failed-to-send";
	OrderState["ScheduledToSend"] = "scheduled-to-send";
	OrderState["HeldForPosPayment"] = "held-for-pos-payment";
	OrderState["Abandoned"] = "abandoned";
	return OrderState;
}({});
//#endregion
export { OrderState };

//# sourceMappingURL=order_state.js.map